import { useEffect, useState } from 'react';
import { pretestError } from './pretestModel';
export default function usePretestPage(load) {
  const [cursor, setCursor] = useState(null); const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ items: [], next: null, loading: true, error: '' });
  useEffect(() => { let active = true; setState({ items: [], next: null, loading: true, error: '' });
    load(cursor).then(data => { if (active) setState({ ...data, loading: false, error: '' }); }).catch(e => { if (active) setState({ items: [], next: null, loading: false, error: pretestError(e) }); });
    return () => { active = false; };
  }, [load, cursor, attempt]);
  return { ...state, cursor, first: () => { setCursor(null); setAttempt(v => v + 1); }, more: () => setCursor(state.next), retry: () => setAttempt(v => v + 1) };
}
